export const companyInfo = {
  name: '武汉俊鑫岚科技有限公司',
  shortName: '俊鑫岚科技',
  domain: '820990.cn',
  slogan: '一站式物资供应，助力企业高效运转',
  phone: '13827693511',
  email: 'xiaomi5033vip@gmail.com',
  address: '湖北省武汉市武昌区中南路街中南路14号世纪广场B座16层A室-2',
  icp: '鄂ICP备2026054372号-1',
  workTime: '周一至周五 09:00 - 18:00',
};

export const aboutFacts = [
  { value: '2026年8月', label: '公司成立' },
  { value: '约1000㎡', label: '办公仓储面积' },
  { value: '200万元', label: '注册资本' },
  { value: '1000+', label: '供应品类' },
];

export const navItems = [
  { label: '首页', href: '#home' },
  { label: '关于我们', href: '#about' },
  { label: '核心优势', href: '#strengths' },
  { label: '主营产品', href: '#services' },
  { label: '合作流程', href: '#process' },
  { label: '联系我们', href: '#contact' },
];

export const heroStats = [
  { value: '1000+', label: '供应品类' },
  { value: '200+', label: '合作厂商' },
  { value: '98%', label: '准时交付率' },
  { value: '24h', label: '快速响应' },
];

export const applicationAreas = [
  { name: '建筑工程', icon: 'ri-building-line' },
  { name: '市政工程', icon: 'ri-community-line' },
  { name: '机械制造', icon: 'ri-settings-3-line' },
  { name: '电子装配', icon: 'ri-cpu-line' },
  { name: '装饰装修', icon: 'ri-home-4-line' },
  { name: '企事业单位', icon: 'ri-government-line' },
];

export const strengths = [
  {
    title: '品类齐全',
    desc: '覆盖建筑建材、机械电气、金属材料、电子配件、五金耗材等多个大类，一站式满足采购需求。',
    icon: 'ri-apps-2-line',
  },
  {
    title: '品质可靠',
    desc: '严格筛选上游货源，坚持正规渠道采购，产品质量稳定，用得放心。',
    icon: 'ri-shield-check-line',
  },
  {
    title: '价格合理',
    desc: '与上游厂商保持长期稳定合作，批量采购降低成本，为客户提供有竞争力的报价。',
    icon: 'ri-price-tag-3-line',
  },
  {
    title: '高效配送',
    desc: '依托完善的备货与物流安排，按约定时间及时供货，不耽误工程与生产进度。',
    icon: 'ri-truck-line',
  },
  {
    title: '专业服务',
    desc: '专属商务对接，提供选型建议、报价核对与代理代办等贴心服务，采购更省心。',
    icon: 'ri-customer-service-2-line',
  },
  {
    title: '合规经营',
    desc: '资质齐全、票据规范、流程透明，让每一次合作都安心可靠。',
    icon: 'ri-file-shield-2-line',
  },
];

export const services = [
  {
    title: '建筑建材',
    desc: '建筑材料、轻质建筑材料、防水防腐材料、涂料（不含危险化学品）、密封件及建筑陶瓷制品等，覆盖工程与装饰用料需求。',
    points: ['建筑材料', '防水防腐材料', '涂料与密封', '建筑陶瓷'],
    icon: 'ri-building-2-line',
  },
  {
    title: '机械电气',
    desc: '机械零件与零部件、机械电气设备、制冷空调设备及电线电缆等，为生产运行与工程项目提供设备配套支持。',
    points: ['机械零件', '机械电气设备', '制冷空调设备', '电线电缆'],
    icon: 'ri-settings-5-line',
  },
  {
    title: '金属材料',
    desc: '金属制品、金属材料、高性能有色金属及合金材料、金属矿石与非金属矿制品等，品类齐全、规格丰富。',
    points: ['金属制品', '有色金属合金', '高性能合金材料', '金属矿石'],
    icon: 'ri-stack-line',
  },
  {
    title: '电子配件',
    desc: '电子产品、电子元器件与机电组件设备等，为电子装配与设备制造环节提供稳定的配套供应。',
    points: ['电子产品', '电子元器件', '机电组件设备'],
    icon: 'ri-cpu-line',
  },
  {
    title: '五金耗材',
    desc: '五金产品、塑料制品、日用百货、办公用品、办公设备耗材、家具及体育用品器材等日常与办公配套。',
    points: ['五金产品', '塑料制品', '办公用品', '日用百货'],
    icon: 'ri-tools-line',
  },
  {
    title: '其他服务',
    desc: '第一类医疗器械销售，以及信息咨询服务（不含许可类）、商务代理代办服务、个人商务服务等配套商务支持。',
    points: ['第一类医疗器械', '信息咨询服务', '商务代理代办', '个人商务服务'],
    icon: 'ri-service-line',
  },
];

export const processSteps = [
  { step: '01', title: '需求沟通', desc: '了解产品品类、规格数量与交付时间等采购需求。' },
  { step: '02', title: '报价选型', desc: '提供产品报价与选型建议，确认采购清单与供货方案。' },
  { step: '03', title: '签约备货', desc: '签订合同、组织备货，按约定安排供货。' },
  { step: '04', title: '配送售后', desc: '准时配送交付，并提供持续补货与售后支持。' },
];

export const testimonials = [
  {
    quote: '品类很全，一次就能把工程需要的材料配齐，报价也实在，省了不少事。',
    name: '刘经理',
    role: '某建筑工程公司 · 采购经理',
  },
  {
    quote: '供货及时、质量稳定，后续补货响应也快，是个靠谱的供应商。',
    name: '陈主管',
    role: '某制造企业 · 供应主管',
  },
  {
    quote: '服务很细致，选型、开票、代办都帮我们安排得明明白白，合作很省心。',
    name: '赵先生',
    role: '某装饰工程 · 项目负责人',
  },
];